/** 课程，素材数据相关 */
import {get, post, postByJson, B_URL,URL_ARRAY} from './https.js';
import {C_URL} from "./https";
const IMPORT_RES_URL = B_URL + 'b0002/importTextBookRes';

export default {
    IMPORT_RES_URL,
    URL_ARRAY,
    /** 课程相关 */
    // 获取全部课程数据
    listAllCourse() {
        return get(B_URL + "b0001/list/all");
    },
    // 获取用户关联的课程数据
    listUserCourse(param) {
        return get(B_URL + "b0001/list/user/course", param);
    },
   // 获取用户课程类型
   getUserCourseType(){
    return get(B_URL + 'b0001/list/user/courseType')
  },

    /** 素材相关 */
    // 分页查询素材
    pagingRes(param) {
        return postByJson(B_URL + "b0002/pagingRes", param);
    },
    // 添加素材
    addResource(param) {
        return postByJson(B_URL + "b0002/add", param);
    },
    // 更新素材
    updateResource(param) {
        return postByJson(B_URL + "b0002/update", param);
    },
    // 素材改名
    renameResource(param) {
        return postByJson(B_URL + "b0002/rename", param);
    },
    // 图片类型转化
    picTypeConversion(param) {
        return postByJson(B_URL + "b0002/picTypeConversion", param);
    },
    // 删除素材
    deleteResource(param) {
        return post(B_URL + "b0002/delete", param);
    },
    // 查询素材详细信息
    getResourceInfo(param) {
        return get(B_URL + "b0002/getInfo", param);
    },
    // 激活页面，查询素材列表
    getResPaging4Active(param) {
        return get(B_URL + "b0002/paging/for/active", param);
    },
    // 共享素材
    shareResource(param) {
        return postByJson(B_URL + "b0002/share", param);
    },
    // 查询共享部门和用户列表
    listDeptAndShareUser(param) {
        return get(B_URL + "b0002/list/share/user", param);
    },
    // 查询学校共享部门和用户列表
    listSchoolAndDeptAndShareUser(param) {
        return get(B_URL + "b0002/list/share/userBySchool", param);
    },
    // 查询课后作业的素材附件信息
    listTaskKhzy(param) {
        return get(B_URL + 'b0002/list/khzy', param);
    },
    /** 知识点相关 */
    // 根据课程ID，父节点ID获取知识点List
    listKp(param) {
        return get(B_URL + "b0003/list", param);
    },

    listResGame(param) {
        return get(B_URL + "b0002/pagingResGame", param);
    },

    saveGame(param) {
        return postByJson(B_URL + 'b0002/saveGame',param)
    },

    // 导出素材
    exportRes(param) {
        return get(B_URL + "b0002/exportTextBookRes", param);
    },
    // 导出素材(压缩成zip文件)
    exportResToZip(param) {
        return post(B_URL + 'b0002/exportTextBookResToZip', param);
    },
}



// WEBPACK FOOTER //
// ./src/components/tools/request/https-b.js